module.exports = __webpack_public_path__ + "static/img/4407fc5c57d94d1f991a2078cc20a1c4.5641fb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4407fc5c57d94d1f991a2078cc20a1c4.jpg
// module id = EDJd
// module chunks = 1